import { w as p } from "./abstract-base-8edf0a84-e11d45a3.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var l = function l(o) {
  return o != null ? o : p;
};
export { l as p };